import React from "react";
import { FormattedMessage } from "react-intl";

import { Button } from "../../../../components/button/Button";
import { Icon } from "../../../../components/icon/Icon";
import { Mobile, NotMobile } from "../../../../hocs/Responsive";

export const PreviewButton = ({ onClick, disabled }) => (
  <Button
    className="preview-button"
    size={"large"}
    color={"secondary"}
    onClick={onClick}
    disabled={disabled}
  >
    <Icon icon="fa-regular fa-eye" />
    <span>
      <NotMobile>
        <FormattedMessage id={"preview_block_page"} />
      </NotMobile>
      <Mobile>
        <FormattedMessage id={"preview_block_page_short"} />
      </Mobile>
    </span>
  </Button>
);
